import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';

const isDev = import.meta.env.DEV;

const lang = isDev ? 'de' : 'de';

i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    lng: lang,
    fallbackLng: ['de'],
    debug: isDev,
    supportedLngs: ['de', 'en'],
    nonExplicitSupportedLngs: true,
    load: 'currentOnly',
    preload: isDev ? ['en', 'de'] : ['de'],
    interpolation: {
      escapeValue: false,
    },
    backend: {
      loadPath: `/locales/{{lng}}/{{ns}}.json?v=${import.meta.env.VITE_APP_VERSION}`,
    },
  });

export default i18n;
